import { useState, useEffect, useCallback } from "react";
import { Modal } from "react-bootstrap";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import CurrencyFormat from "react-currency-format";
import moment from "moment";
import axiosInstance from "../../utils/axiosInstance";
import Toast from "../../components/Toast/Toast";
import ButtonBasic from "../../components/Buttons/ButtonBasic";
import buttonChecker from "../../utils/buttonsPermissionsChecker";
import AddCassettesConfiguration from "../DetailView/AtmList/atm-replenishment/AddCassettesConfiguration";
import { useDateTime } from "../../components/Helper/DateTime";
import LoaderComponent from "../../components/Spinner/LoaderComponent";
import { WorkQueueLogStyle } from "./Styles";
import { CustomTooltip } from "../../utils/helpers/custom-tooltip";
import { Alert } from "react-bootstrap";
import { DateTimeFormat } from "../../utils/formatDateTime";

const FormSchema = Yup.object().shape({
  comment: Yup.string().min(2, "Too Short!").required("Required*"),
});

const AtmReplenishmentModal = ({
  id,
  handleCloseModal,
  fetchWorkQueue,
  show,
  onHide,
  singleRow,
}) => {
  const { currency, dateTime } = useDateTime();
  const [workQueueData, setWorkQueueData] = useState({});
  const [loadingModal, setLoadingModal] = useState(false);
  //const [action, setAction] = useState(null);
  const userData = JSON.parse(localStorage.getItem("userData"));

  const getWorkQueue = useCallback(async () => {
    setLoadingModal(true);
    try {
      const res = await axiosInstance.get(`/work-queue/work-item?itemId=${id}`);
      if (res.message.status !== "200") {
        setLoadingModal(false);
        Toast(res.message.description, "error");
      } else {
        setWorkQueueData(res?.data);
        setLoadingModal(false);
      }
    } catch (err) {
      setLoadingModal(false);
      console.log("error", err);
    }
  }, [id]);

  useEffect(() => {
    getWorkQueue();
  }, [getWorkQueue]);

  const addNote = (values) => {
    let now = moment();
    let note = {
      comment: values?.comment,
      author: `${userData?.firstName} ${userData?.lastName}`,
      date: now.format("DD/MM/YY"),
      time: now.hour() + ":" + now.minute(),
    };
    // setComment("");
    let notes = workQueueData?.notes || [];
    notes.push(note);
    setWorkQueueData({ ...workQueueData, notes: notes });
  };

  const handleDone = async (value) => {
    setLoadingModal(true);
    try {
      let response = await axiosInstance.put("/work-queue/work-item", {
        workItemId: id,
        action: value,
        notes: workQueueData?.notes,
        userId: userData?.userId,
      });
      if (response.message.status !== "200") {
        setLoadingModal(false);
        Toast(response.message.description, "error");
      } else {
        handleCloseModal();
        setLoadingModal(false);
        fetchWorkQueue();
      }
    } catch (err) {
      setLoadingModal(false);
      Toast(err.response.data.message.description, "error");
      console.log(err);
    }
  };

  const formatAmount = (amount) =>
    amount ? (
      <CurrencyFormat
        value={amount}
        displayType={"text"}
        thousandSeparator={true}
        prefix={`${currency} `}
      />
    ) : (
      "0"
    );
  return (
    <>
      <WorkQueueLogStyle>
        <Modal
          backdrop={true}
          size="xl"
          show={show}
          onHide={onHide}
          aria-labelledby="example-modal-sizes-title-lg"
        >
          <Modal.Header className="pb-0" closeButton></Modal.Header>
          <Modal.Body scrollable="true">
            {loadingModal && (
              <div
                className="spinner-center"
                style={{ top: "0%", left: "0%", zIndex: 2000 }}
              >
                <LoaderComponent />
              </div>
            )}
            <div className="container">
              <div
                className="row"
                style={{
                  opacity: !loadingModal ? "1" : "0.07",
                }}
              >
                <div className="col-8 overflow-auto">
                  <div className="col-sm-12 col-lg-12">
                    <span className="color-gray-dim">Queue Item:</span> {id}
                  </div>

                  <div className="row">
                    <div className="col-sm-12 col-lg-6">
                      <div className="key-value-wrapper info-tile">
                        <div className="key color-light">Device ID</div>
                      </div>
                    </div>
                    <div className="col-sm-12 col-lg-6">
                      <div className="key-value-wrapper info-tile">
                        <div className="value color-dark">
                          {workQueueData?.deviceId || "Nill"}
                        </div>
                      </div>
                    </div>

                    <div className="col-sm-12 col-lg-6">
                      <div className="key-value-wrapper info-tile">
                        <div className="key color-light">Last Ref</div>
                      </div>
                    </div>
                    <div className="col-sm-12 col-lg-6">
                      <div className="key-value-wrapper info-tile">
                        <div className="value color-dark">
                          {workQueueData?.lastRef || "Nill"}
                        </div>
                      </div>
                    </div>

                    <div className="col-sm-12 col-lg-6">
                      <div className="key-value-wrapper info-tile">
                        <div className="key color-light">Raised By</div>
                      </div>
                    </div>
                    <div className="col-sm-12 col-lg-6">
                      <div className="key-value-wrapper info-tile">
                        <div className="value color-dark">
                          {workQueueData?.raisedBy || "Nill"}
                        </div>
                      </div>
                    </div>

                    <div className="col-sm-12 col-lg-6">
                      <div className="key-value-wrapper info-tile">
                        <div className="key color-light">Authorizer</div>
                      </div>
                    </div>
                    <div className="col-sm-12 col-lg-6 ">
                      <div className="key-value-wrapper info-tile h-100">
                        <div className="value color-dark">
                          {workQueueData?.authorizer || ""}
                        </div>
                      </div>
                    </div>

                    <div className="col-sm-12 col-lg-6">
                      <div className="key-value-wrapper info-tile">
                        <div className="key color-light">
                          Replenishment Date And Time
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-12 col-lg-6">
                      <div className="key-value-wrapper info-tile">
                        <div className="value color-dark">
                          {workQueueData?.dateTime
                            ? DateTimeFormat(dateTime, workQueueData?.dateTime)
                            : "Nill"}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-4">
                  <div className="notes-wrapper">
                    <h5 className="mb-3 color-gray-dim">Notes</h5>
                    <div
                      className="overflow-auto fancy-scroll"
                      style={{ height: "7.5em" }}
                    >
                      {workQueueData?.notes?.map(
                        ({ author, comment, date, time }, i) => (
                          <ul className="rs-notes-container" key={i}>
                            <li className="rs-notes-item">
                              <h6>{author}</h6>
                              <div className="note-comment">{comment}</div>
                              <sub>
                                {date} {time}
                              </sub>
                            </li>
                          </ul>
                        )
                      )}
                    </div>

                    <Formik
                      initialValues={{
                        comment: "",
                      }}
                      validationSchema={FormSchema}
                      onSubmit={(values, { resetForm }) => {
                        addNote(values);
                        resetForm({ values: "" });
                      }}
                    >
                      {({ errors, touched, handleSubmit, handleReset }) => (
                        <Form
                          id="add-notes"
                          className="form"
                          onSubmit={handleSubmit}
                          onReset={handleReset}
                        >
                          <div className="row mt-3">
                            <div className="col-12 mt-3">
                              <div className="d-flex flex-column">
                                <Field
                                  as="textarea"
                                  className="rs-input"
                                  placeholder="Write a Note"
                                  rows="3"
                                  name="comment"
                                />
                                {errors.comment && touched.comment ? (
                                  <div className="field-error">
                                    {errors.comment}
                                  </div>
                                ) : null}
                              </div>
                            </div>
                          </div>
                          <div className="w-100 mt-2">
                            <ButtonBasic
                              type="submit"
                              classes={"primary px-4 w-100"}
                              title={"Add Note"}
                              onClick={handleSubmit}
                            />
                          </div>
                        </Form>
                      )}
                    </Formik>
                  </div>
                  {!workQueueData?.notes ? (
                    <div className="field-error">
                      Notes field is required incase of Reject/Approve*{" "}
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
            <Formik
            // onSubmit={(values) => {
            // }}
            >
              {() => {
                return (
                  <>
                    <div
                      className="container"
                      style={{
                        opacity: !loadingModal ? "1" : "0.07",
                      }}
                    >
                      {/* cash Unload starts */}
                      <div className="container">
                        <div className="row">
                          {/* 50% column left starts*/}
                          <div className="col-md">
                            <h5 className="pt-5">Cash Unload</h5> <br />
                            <h6 className="text-info">Ej</h6>
                            <div className="row mt-3 d-flex justify-content-start  align-items-start">
                              <div className="col-md">
                                <div className="text-left">Denom</div>
                              </div>
                              <div className="col-md">
                                <div className="text-left">Bill Count</div>
                              </div>

                              <div className="col-md">
                                <div className="text-left">Type</div>
                              </div>

                              <div className="col-md">
                                <div className="text-left">Total</div>
                              </div>
                            </div>
                            <AddCassettesConfiguration
                              rowsData={workQueueData?.ejCashUnLoadData || []}
                              isCassetteType={true}
                              isReview={true}
                            />
                            <div className="row d-flex justify-content-center mt-4">
                              <div className="col-10 text-left">
                                Total Cash Unload:{" "}
                                {formatAmount(
                                  workQueueData?.ejCashUnLoadTotalAmount
                                )}
                              </div>
                            </div>
                          </div>
                          {/* 50% column right starts*/}
                          <div className="col-md">
                            <h5 className="pt-5">Cash Load</h5> <br />
                            <h6 className="text-info">Ej</h6>
                            <div className="row mt-3 d-flex justify-content-start  align-items-start">
                              <div className="col-md">
                                <div className="text-left">Denom</div>
                              </div>
                              <div className="col-md">
                                <div className="text-left">Bill Count</div>
                              </div>

                              <div className="col-md">
                                <div className="text-left">Type</div>
                              </div>

                              <div className="col-md">
                                <div className="text-left">Total</div>
                              </div>
                            </div>
                            <AddCassettesConfiguration
                              rowsData={workQueueData?.ejCashLoadData || []}
                              isCassetteType={true}
                              isReview={true}
                            />
                            <div className="row d-flex justify-content-center mt-4">
                              <div className="col-10 text-left">
                                Total Cash Load:{" "}
                                {formatAmount(
                                  workQueueData?.ejCashLoadTotalAmount
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* cash Load starts */}
                      <div className="container mt-5 pb-5">
                        <div className="row">
                          {/* 50% column left starts*/}
                          <div className="col-md">
                            <h6 className="text-info">Physical Cash Count</h6>
                            <div className="row mt-3 d-flex justify-content-start  align-items-start">
                              <div className="col-md">
                                <div className="text-left">Denom</div>
                              </div>
                              <div className="col-md">
                                <div className="text-left">Bill Count</div>
                              </div>

                              <div className="col-md">
                                <div className="text-left">Total</div>
                              </div>
                            </div>
                            <AddCassettesConfiguration
                              rowsData={workQueueData?.citCashUnLoadData || []}
                              isCassetteType={false}
                              isReview={true}
                            />
                            <div className="row d-flex justify-content-center mt-4">
                              <div className="col-10 text-left">
                                Total Cash Unload:{" "}
                                {formatAmount(
                                  workQueueData?.citCashUnLoadTotalAmount
                                )}
                              </div>
                            </div>
                          </div>
                          {/* 50% column right starts*/}
                          <div className="col-md">
                            <h6 className="text-info">Physical Cash Count</h6>
                            <div className="row mt-3 d-flex justify-content-start  align-items-start">
                              <div className="col-md">
                                <div className="text-left">Denom</div>
                              </div>
                              <div className="col-md">
                                <div className="text-left">Bill Count</div>
                              </div>

                              <div className="col-md">
                                <div className="text-left">Total</div>
                              </div>
                            </div>
                            <AddCassettesConfiguration
                              rowsData={workQueueData?.citCashLoadData || []}
                              isCassetteType={false}
                              isReview={true}
                            />
                            <div className="row d-flex justify-content-center mt-4">
                              <div className="col-10 text-left">
                                Total Cash Load:{" "}
                                {formatAmount(
                                  workQueueData?.citCashLoadTotalAmount
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      {workQueueData?.ejCashUnLoadTotalAmount !==
                        workQueueData?.citCashUnLoadTotalAmount && (
                        <div className="row">
                          <div className="col-12 d-flex justify-content-center ">
                            <Alert variant="warning">
                              {`Warning: Total Cash Unload amounts (EJ Slip & Physical Cash Count ) are not equal!`}
                            </Alert>
                          </div>
                        </div>
                      )}

                      {workQueueData &&
                        workQueueData?.ejCashLoadTotalAmount !==
                          workQueueData?.citCashLoadTotalAmount && (
                          <div className="row">
                            <div className="col-12 d-flex justify-content-center ">
                              <Alert variant="danger">
                                {`Error: Total Cash Load amounts (EJ & Physical Cash Count) are not equal. Go Back and correct Total amount values.`}
                              </Alert>
                            </div>
                          </div>
                        )}
                      <div className="container">
                        <div className="row">
                          <div className="col-sm-5 mt-3">
                            {workQueueData?.workItemStatus === "APPROVED" ||
                            workQueueData?.workItemStatus === "DECLINED" ? (
                              ""
                            ) : (
                              <div className="alert alert-danger" role="alert">
                                This work item requires approval.
                              </div>
                            )}
                          </div>
                          <div className="offset-sm-4 col-sm-3 text-right mt-3">
                            <CustomTooltip
                              placement="top"
                              tooltipId="button-tooltip-2"
                              disabled={
                                !buttonChecker("clk_authorise_work_item") ||
                                workQueueData?.workItemStatus === "APPROVED" ||
                                workQueueData?.workItemStatus === "DECLINED" ||
                                !workQueueData?.notes ||
                                workQueueData?.raisedById === userData?.userId
                              }
                              disabledMessage={
                                workQueueData?.workItemStatus === "APPROVED"
                                  ? "Already Approved"
                                  : workQueueData?.workItemStatus === "DECLINED"
                                  ? "Already Declined"
                                  : workQueueData?.raisedById ===
                                    userData?.userId
                                  ? "You are not allowed to approve or reject the work item"
                                  : !workQueueData?.notes
                                  ? "Add Notes"
                                  : "Permission Denied"
                              }
                              onClick={() => {
                                if (
                                  workQueueData?.notes &&
                                  workQueueData?.notes !== undefined
                                ) {
                                  handleDone(0);
                                }
                              }}
                              buttonText="Reject"
                            >
                              Reject
                            </CustomTooltip>{" "}
                            <CustomTooltip
                              placement="top"
                              tooltipId="button-tooltip-2"
                              disabled={
                                !buttonChecker("clk_authorise_work_item") ||
                                workQueueData?.workItemStatus === "APPROVED" ||
                                workQueueData?.workItemStatus === "DECLINED" ||
                                !workQueueData?.notes ||
                                workQueueData?.raisedById === userData?.userId
                              }
                              disabledMessage={
                                workQueueData?.workItemStatus === "APPROVED"
                                  ? "Already Approved"
                                  : workQueueData?.workItemStatus === "DECLINED"
                                  ? "Already Declined"
                                  : workQueueData?.raisedById ===
                                    userData?.userId
                                  ? "You are not allowed to approve or reject the work item"
                                  : !workQueueData?.notes
                                  ? "Add Notes"
                                  : "Permission Denied"
                              }
                              onClick={() => handleDone(1)}
                              buttonText="Approve"
                            >
                              Approve
                            </CustomTooltip>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                );
              }}
            </Formik>
          </Modal.Body>
        </Modal>
      </WorkQueueLogStyle>
    </>
  );
};
export default AtmReplenishmentModal;
